export const EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE = -1;

export const EXCLUDE_OPTION = {
  label: 'Exclude from Asset Bucketing',
  value: EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE,
};
